function changeProtoType(name, prototype) {
  createPrototype.call(this, name, prototype, 'prototype');
}

function change__proto__(name, prototype) {
  createPrototype.call(this, name, prototype, '__proto__');
}

function createPrototype(name, prototype, type) {
  try {
    if (typeof prototype == 'function')
      if (name) {
        if (prototype.name != name)
          console.error('Function name and prototype name should be the same');
        // throw new TypeError(
        //   "Function name and prototype name should be the same"
        // );
      } else if (prototype.name) name = prototype.name;
      else throw new TypeError('Function name is requiredsss');
    Object.defineProperty(this[type], name, {
      value: prototype,
      writable: true,
      enumerable: false,
      configurable: true,
    });
  } catch (error) {
    console.error(`${error.name}: ${error.message}`);
  }
}

function createCustomProto(
  newProtos,
  keepSelfProto = false,
  keepChildProto = false,
) {
  try {
    if (typeof newProtos != 'object')
      throw new TypeError(
        'New prototypes required to be passed inside an object.',
      );
    newProtos = Object.entries(newProtos);
    if (!keepSelfProto) this.__proto__ = function () {};
    if (keepChildProto) Assign.call(this, newProtos);
    else clearAndAssign.call(this, newProtos);
  } catch (error) {
    console.error(`${error.name}: ${error.message}`);
  }
}

function clearAndAssign(newProtos) {
  for (const [name, value] of newProtos) {
    value.__proto__ = null;
    change__proto__.call(this, name, value);
  }
}

function Assign(newProtos) {
  for (const [name, value] of newProtos) {
    change__proto__.call(this, name, value);
  }
}

changeProtoType.call(Function, 'createCustomProto', createCustomProto);

changeProtoType.call(Object, 'isEmpty', function isEmpty() {
  return Object.keys(this).length === 0;
});

changeProtoType.call(String, 'capitalize', function capitalize() {
  return this.replace(/^\w/, (c) => c.toUpperCase());
});

changeProtoType.call(Date, '_addDays', function _addDays(days) {
  this.setDate(this.getDate() + days);
  return this;
});
changeProtoType.call(Date, 'toISODateString', function toISODateString(days) {
  return this.toISOString().split('T')[0];
});

export { createPrototype, changeProtoType, change__proto__ };
